






























import { Vessel } from "@/types/vessel";
import { Component, Vue, PropSync, Prop } from "vue-property-decorator";
import VesselSelect from "../VesselGroup/VesselSelect.vue";
import MetricSelect from "../MetricSelect/MetricSelect.vue";
import DfiFieldWrapper from "../DfiForm/DfiFieldWrapper.vue";
import { Metric } from "@/types/vesselComparison";

@Component({
  components: {
    DfiFieldWrapper,
    VesselSelect,
    MetricSelect,
  }
})
export default class VesselComparisonFilters extends Vue {
  @PropSync("vessels") vesselsSync!: Vessel[];
  @PropSync("metrics") metricsSync!: string[];
  @Prop() vesselsList!: Vessel[];
  @Prop() metricsList!: Metric[];
  @Prop() metricsLoading!: boolean;
  
  nameFilter: string = "";

  get filteredVessels(): Vessel[] {
    return this.vesselsList.filter(vessel =>
      vessel.name.toLowerCase().includes(this.nameFilter.toLowerCase())
    );
  }

  compare() {
    this.$emit("compare");
  }
}
